module.exports = __webpack_public_path__ + "static/media/img/iso20022-guide_comparison.webp";